import { Row, Col, Button, Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import ViewMoreIcon from "../../assets/right-arrow.svg";
import BannerImage from "../../assets/cmc.jpg";

import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";

import "./Blog.css";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate
  const [blogvisible , setBlogVisible] = useState(2)
  const [loading, setLoading] = useState(false);
  

  const trimText = (text, maxLength) => {
    if (!text) return '';
    const isTruncated = text.length > maxLength;
    const visibleText = text.slice(0, maxLength);
    return (
      <>
      {visibleText}
      {isTruncated && <span style={{ color: '#000000',fontWeight:'700', fontSize:"12px"  }}>... View more</span>}
    </>
    )
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = () => {
    setLoading(true)
    axios
      .get(baseUrl + "/app/blog/")
      .then((response) => {
        setBlogs(response.data);
        setLoading(false)
        console.log("Blogs:", JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log("Error fetching blogs:", error);
        setLoading(false)
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }).format(date);
  };


  return (
    <section className="blog" id="blog">
      <Container>
        {blogvisible && (
        <div className="blog-content">
          <div className="section-title pt-5">Blog</div>
          { loading ?  <div className="loader"><Spinner className="loading-color"/></div>: <Row className="blog-row">
            {blogs.slice(0, blogvisible).map((item, index) => (
              <Col
                lg={4}
                className="blog-image pt-3"
                key={index}
                onClick={() => navigate(`/blog-details/`, { state: { blog: item } })}
                style={{ cursor: "pointer" }} // Make it look clickable
              >
                <div className="blog-post">
                  <img
                    src={item.image}
                    alt="Blog Image"
                    className="img-fluid"
                  />
                  <div className="blog-title py-3">{item.title}</div>
                  <div className="blog-content py-2">{trimText(item.content,100)}</div>
                  <div className="blog-author pt-4">{item.author_name}</div>
                  <div className="blog-date">{formatDate(item.created_at)}</div>
                </div>
              </Col>
            ))}
          </Row>  }
          
          {blogs.length > 6 && (
          <div className="view-more ">
            <Button
            href="/viewmoreblog"
            className="view-more-btn"
            >
              View More <img src={ViewMoreIcon} />
            </Button>
          </div>
          )}
        </div>
         )}
      </Container>
    </section>
  );
}

export default Blog;
